import { render, staticRenderFns } from "./AddRelayModal.vue?vue&type=template&id=16fda581"
import script from "./AddRelayModal.vue?vue&type=script&lang=js"
export * from "./AddRelayModal.vue?vue&type=script&lang=js"
import style0 from "./AddRelayModal.vue?vue&type=style&index=0&id=16fda581&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports